import styled from '@emotion/styled';

export const Layout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
